import { getPurchasedProductsReport } from "@iewccouk/Services/CommonService";
import { CustomState } from "@iewccouk/Store/Reducers";
import { PurchasesByProductModel } from "@iewccouk/Types/CustomApiModels";

import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";

type PurchasesByProductParameter = HasOnSuccess & HasOnError;

type HandlerType = ApiHandlerDiscreteParameter<PurchasesByProductParameter, { year: number }, PurchasesByProductModel>;

export const PopulateApiParameter: HandlerType = props => {
    const year = (props.getState() as CustomState).customPurchasesByProductState.yearSelected;
    props.apiParameter = {
        year,
    };
};

export const SendDataToApi: HandlerType = async props => {
    const data = await getPurchasedProductsReport(props.apiParameter.year);
    if (data.successful) {
        props.apiResult = data.result;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult) {
        props.dispatch({
            type: "Custom/PurchasesByProductState/SetData",
            data: props.apiResult,
        } as any);
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.();
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult) {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.();
    }
};

export const DispatchFinishData: HandlerType = props => {
    props.dispatch({
        type: "Custom/PurchasesByProductState/SetIsLoading",
        isLoading: false,
    } as any);
};

export const chain = [
    PopulateApiParameter,
    SendDataToApi,
    ExecuteOnSuccessCallback,
    ExecuteOnErrorCallback,
    DispatchFinishData,
];

const loadPurchasesByProduct = createHandlerChainRunner(chain, "LoadPurchasesByProduct");
export default loadPurchasesByProduct;
